export default __webpack_public_path__ + "static/media/Snd_Try0.81bccbf7.mp3";